import { AppState } from './app-state.interface';
import { appActions } from './app-actions.type';

export const appStateReducer = (state: AppState, action: appActions): AppState => {
  switch (action.type) {
    case 'OpenSubSideBar': {
      state.layout.sidebar.openSubSidebar = !state.layout.sidebar.openSubSidebar;
      return { ...state };
    }
    case 'SelectSidebarItem': {
      return {
        ...state,
        layout: {
          ...state.layout,
          sidebar: {
            ...state.layout.sidebar,
            selected: action.payload,
            openSubSidebar: true
          }
        }
      };
    }
    case 'UpdateSidebarItem': {
      return {
        ...state,
        layout: {
          ...state.layout,
          sidebar: {
            ...state.layout.sidebar,
            items: action.payload,
            selected: Object.keys(action.payload).includes(state.layout.sidebar.selected)
              ? state.layout.sidebar.selected
              : Object.keys(state.layout.sidebar.items)[0]
          }
        }
      };
    }
    case 'RemoveSidebarItem': {
      const { [action.payload]: _, ...newItems } = state.layout.sidebar.items;
      return {
        ...state,
        layout: {
          ...state.layout,
          sidebar: {
            ...state.layout.sidebar,
            items: newItems,
            selected: Object.keys(newItems).includes(state.layout.sidebar.selected)
              ? state.layout.sidebar.selected
              : Object.keys(newItems)[0]
          }
        }
      };
    }
  }
};
